import { render, staticRenderFns } from "./paper_download_list.vue?vue&type=template&id=36713320"
import script from "./paper_download_list.vue?vue&type=script&lang=js"
export * from "./paper_download_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports